export const teamEditedSuccessfully = `Team’s data is being processed. It might take a few minutes.`;
export const teamCreatedSuccessfully = `Team’s data is being processed. It might take a few minutes. Want to invite a Team Leader or other member to use LinearB? `;
export const teamClicked = `Showing the current team contributors. Changes done in the past are not reflected in this view.`;
export const teamMsteamsUnlinkedSuccessfully = `was unlinked from Microsoft teams Successfully`;
export const teamMsteamsUnlinkedFailed = teamName =>
  `Failed to unlink ${teamName} from Microsoft teams`;
